<template>
  <Head>
    <title>Обмен недвижимости {{ $titleEnd }}</title>
    <meta property="og:title" :content="'Trade-in ' + $titleEnd" />
  </Head>
  <div class="trade-in-special">
    <main class="main">
      <div class="container">
        <div
          id="realisteWidget"
          data-widget="https://very-botsad-test.realiste.ai/object-evaluation"
        ></div>
      </div>
    </main>
  </div>
</template>

<script>
import { Head } from "@vueuse/head";
export default {
  components: {
    Head,
  },
  created() {
    this.$createRealisteWidget();
  },
};
</script>
